import axios from 'axios';

export const getAdminBaseUrl = () => {
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'http://localhost/multimilla/lsapp/public/api/v1/';
        }
    }
    return 'https://backend.multimilla.com/public/api/v1/';
};

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
    config => {
        config.baseURL = getAdminBaseUrl();
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        console.log(`📤 Request: ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
        return config;
    },
    error => {
        console.error('❌ Request Error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for better error handling
axiosInstance.interceptors.response.use(
    response => {
        console.log(`✅ Response: ${response.config.method?.toUpperCase()} ${response.config.url} - ${response.status}`);
        return response;
    },
    error => {
        if (error.response) {
            console.error(`❌ Response Error [${error.response.status}]:`, {
                url: error.config?.url,
                data: error.response.data,
                message: error.response.data?.message || error.response.data?.error || 'Server error'
            });

            // Handle unauthorized or expired session
            if (error.response.status === 401 || error.response.status === 403) {
                localStorage.removeItem('token');
                if (typeof window !== 'undefined') {
                    const currentPath = window.location.pathname;
                    // Only redirect if not already on the login page
                    if (currentPath !== '/' && !currentPath.endsWith('/login')) {
                        console.warn('⚠️ Session expired or invalid admin token. Redirecting to login...');
                        window.location.href = '/';
                    }
                }
            }
        } else if (error.request) {
            console.error('❌ Network Error (No response from server):', error.request);
        } else {
            console.error('❌ Request Setup Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
